import Vue from 'vue'
import App from './App.vue'
import '@common/css/index.scss'
import router from '@router/index.js'
import {
  Message,
  Icon,
  Carousel,
  CarouselItem,
  Table,
  TableColumn,
  Select,
  Option,
  Switch,
  Input,
  InputNumber,
  Form,
  Pagination,
  Dialog,
  Drawer,
  Progress,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Button,
  Image,
  Tooltip,
  Cascader,
  CascaderPanel,
  Tabs,
  TabPane,
  DatePicker,
  TimePicker,
  Upload,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 解决：没有添加被动事件监听器来阻止'touchstart'事件，请考虑添加事件管理者'passive'，以使页面更加流畅。原因是 Chrome51 版本以后，Chrome 增加了新的事件捕获机制－Passive Event Listeners；
import 'default-passive-events'

// import InfiniteScroll from 'vue-infinite-scroll'

import * as echarts from 'echarts'
import CreateAxios from '@api/axios'

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper /* { default options with global component } */)

import { parse_cell_data, imageUrlBlob2Base64 } from '@utils/utils'
import VueLazyload from 'vue-lazyload'

import passPort from './utils/passport'

import {
  isTrue,
  openNewWeb,
  pageJump,
  pageReplaceJump,
} from './utils/globalProperties'

import VueAliplayerV2 from 'vue-aliplayer-v2'
import customizePro from '@customizeProMixins/getCustomizePro'

const link = document.querySelector('link[rel="icon"]');
if (link) {
  link.href = `/favicon/${customizePro || 'mixtmt'}.ico`
}

Vue.use(VueAliplayerV2)

// 开发模式下启用devtools
Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production'

const EventEmitter = require('events')
const emitter = new EventEmitter()
emitter.setMaxListeners(15) // 设置nodejs 最大监听数量为15

Vue.use(VueLazyload)
Vue.use(Icon)
// Vue.use(Message);
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Switch)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Form)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Drawer)
Vue.use(Progress)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Button)
Vue.use(Image)
Vue.use(Tooltip)
Vue.use(Cascader)
Vue.use(CascaderPanel)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Upload)
Vue.prototype.parse_cell_data = parse_cell_data

// mixtmtChart 注册图表组件
// const context_mixChart = require.context(
//   './components/mixtmtChart',
//   true,
//   /\.vue/
// )
// context_mixChart.keys().forEach((ele) => {
//   const component = context_mixChart(ele).default
//   component.name && Vue.component(component.name, component)
// })

// 注册足球图表组件
const context_mixFootballChart = require.context(
  './components/football',
  true,
  /\.vue/
)
context_mixFootballChart.keys().forEach((ele) => {
  const component = context_mixFootballChart(ele).default
  component.name && Vue.component(component.name, component)
})

// 注册基础组件
const context_base = require.context('./components/base', true, /\.vue/)
context_base.keys().forEach((ele) => {
  const component = context_base(ele).default
  component.name && Vue.component(component.name, component)
})

// 注册超赛平台基础组件
const context_platfromBase = require.context(
  './components/platfromBase',
  true,
  /\.vue/
)
context_platfromBase.keys().forEach((ele) => {
  const component = context_platfromBase(ele).default
  component.name && Vue.component(component.name, component)
})

let DynamicConfig = null
CreateAxios.get('./static/dynamicConfig.json', {
  baseURL: '/',
}).then((res) => {
  // console.debug('res:', res)
  DynamicConfig = res.data
  // 解析compstyle的动态组件
  Vue.filter('parseCompStyle', (item) => {
    return item.viewType || item.compStyle
  })

  Vue.config.productionTip = false

  Vue.prototype.$vw = function (px, clientWidth) {
    let width = clientWidth ? clientWidth : 375
    return `${(((px ? px : 0) / width) * 100).toFixed(3)}vw`
  }

  Vue.prototype.$px = function (vw, clientWidth) {
    let width = clientWidth ? clientWidth : 375
    return `${(((vw ? vw : 0) / 100) * width).toFixed(3)}`
  }

  Vue.prototype.$echarts = echarts
  Vue.prototype.$axios = CreateAxios
  Vue.prototype.$message = Message
  Vue.prototype.$dynamicConfig = DynamicConfig
  Vue.prototype.$localStorage = window.localStorage
  Vue.prototype.root_passport = passPort
  Vue.prototype.root_isTrue = isTrue
  Vue.prototype.$imageUrlBlob2Base64 = imageUrlBlob2Base64

  Vue.prototype.pageJump = pageJump
  Vue.prototype.openNewWeb = openNewWeb
  Vue.prototype.pageReplaceJump = pageReplaceJump

  new Vue({
    router,
    render: (h) => h(App),
  }).$mount('#app')
})
